/**
 * @description  Tag manager provider
 */
export default Object.freeze({
  GTM: 'gtm',
  TAG_COMMANDER: 'tagcommander',
  MATOMO: 'matomo',
})
